export function getMarketingMainPageCacheKey({
  slug,
  marketingPageId,
  isPreview,
  adp,
}: {
  slug?: string;
  marketingPageId: number;
  isPreview: boolean;
  adp?: string;
}) {
  const pageIdentity = slug || marketingPageId;
  const previewIdentity = isPreview ? 'preview' : 'live';
  const adpIdentity = adp?.trim() ? encodeURIComponent(adp.trim()) : 'no-adp';

  return `marketing-main:${pageIdentity}:${previewIdentity}:adp=${adpIdentity}`;
}
